var rellax = new Rellax('.rellax');